<article class="post-exam-assessment" *ngIf="assessment">
  <header class="assessment-header screen-only">
    <span class="assessment-icon" aria-hidden="true"><i class="fas fa-sparkles"></i></span>
    <h2>Post Exam Assessment</h2>
    <button class="btn btn-link assessment-print-button" type="button" (click)="print()">
      <i class="fas fa-print" aria-hidden="true"></i>
      Print
    </button>
  </header>

  <div class="print-title">Post Exam Assessment</div>

  <div class="assessment-summary">
    <dw-html-view [ngModel]="assessment.SummaryHeading"></dw-html-view>
  </div>

  <button class="btn btn-link full-summary-toggle screen-only" type="button"
    [attr.aria-expanded]="showFullSummary" (click)="toggleFullSummary()">
    <i class="fas" [ngClass]="showFullSummary ? 'fa-arrow-left' : 'fa-arrow-right'" aria-hidden="true"></i>
    {{ showFullSummary ? 'Hide Full Summary' : 'Show Full Summary' }}
  </button>

  <div class="full-summary" [hidden]="!showFullSummary">
    <dw-html-view [ngModel]="assessment.SummaryFull"></dw-html-view>
  </div>
</article>

<div class="assessment-state" *ngIf="loading">Loading post exam assessment...</div>
<div class="assessment-state" *ngIf="!loading && !assessment">No post exam assessment is available.</div>
